import cn from 'classnames';

import { useRouteContext } from 'src/hooks/useRouteContext';

import DWLogo from 'assets/icons/dw-logo.svg';

import Link from 'components/BaseHelpers/Link';
import StartIndex from 'components/BaseHelpers/StartIndex';
import StopIndex from 'components/BaseHelpers/StopIndex';

import { ComponentProps } from '../../../types/component-props';
import { CoreGlobalNavigationHeaderData } from '../../../types/components';
import MegaMenu from './components/MegaMenu';
import SearchInput from './components/SearchInput';
import { useObserveHero } from './useObserveHero';

import styles from './CoreGlobalNavigationHeader.module.scss';

export type CoreGlobalNavigationHeaderProps = ComponentProps & CoreGlobalNavigationHeaderData;

const CoreGlobalNavigationHeader = (props: CoreGlobalNavigationHeaderProps): JSX.Element => {
  const { search, primaryNav, ancillaryNav, socialMedia } = props.fields;

  const { routeData } = useRouteContext();
  const { isHeroVisible } = useObserveHero();

  return (
    <>
      <StopIndex />
      <header
        className={cn(styles.main, {
          [styles['hero-not-visible']]: !isHeroVisible,
        })}
      >
        <a href="#main" className={styles['skip-link']}>
          {'Skip to main content'}
        </a>
        <div className={cn(styles.container, 'container-12')}>
          {routeData?.route.path === '/' ? (
            <h1 aria-label="Dickinson Wright" className={styles['img-container']}>
              <DWLogo className={styles.logo} />
            </h1>
          ) : (
            <Link
              href="/"
              aria-label="Go To Dickinson Wright Homepage"
              className={styles['img-container']}
            >
              <DWLogo className={styles.logo} />
            </Link>
          )}
          <SearchInput {...search} className={styles['search-input']} />
          <MegaMenu
            primaryNav={primaryNav}
            ancillaryNav={ancillaryNav}
            socialMedia={socialMedia}
            className={styles['mega-menu']}
          />
        </div>
      </header>
      <StartIndex />
    </>
  );
};

export default CoreGlobalNavigationHeader;
